export const DS_SLIDER_INPUT_CLASSES = {
  Root: "ds-slider-input",
  Controls: "ds-slider-input__controls",
  Slider: "ds-slider-input__slider",
  Input: "ds-slider-input__input",
  TickMarks: "ds-slider-input__tick-marks",
  Tick: "ds-slider-input__tick",
  ThumbIconTrack: "ds-slider-input__thumb-icon-track",
  ThumbIcon: "ds-slider-input__thumb-icon",
  NumberField: "ds-slider-input__number-field",
} as const;
